import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./../css/WhatsApp.css";
function WhatsApp() {
  return (
    <a
      href=" https://wa.me/8801766295981"
      target="_BLANK"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon className="whatsapp-icon" icon={faWhatsapp} />
    </a>
  );
}

export default WhatsApp;
